/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IHelp, IOrderSummary, IPaymentMethods } from '@msdyn365-commerce-modules/order-management';
import { IGroup, IGroupDelivery, IGroups } from '@msdyn365-commerce-modules/order-management';
import { IOrderInformation } from '@msdyn365-commerce-modules/order-management';
import { ISalesLine } from '@msdyn365-commerce-modules/order-management';
import { IOrderConfirmationViewProps } from './pgr_b2b_order_confirmation';
import { IImageSettings, Image } from '@msdyn365-commerce/core';

export const OrderConfirmationOrderInfomation: React.FC<IOrderInformation> = ({
    orderInformationProps,
    receiptEmail,
    createdDate,
    channelReferenceId
}) => (
    <Node {...orderInformationProps}>
        {createdDate}
        {channelReferenceId}
        {receiptEmail}
    </Node>
);

export const OrderConfirmationSalesLine: React.FC<ISalesLine> = ({ salesLineProps, salesLine, buyAgainButton }) => (
    <Node {...salesLineProps}>{salesLine}</Node>
);

export const OrderConfirmationGroupDelivery: React.FC<IGroupDelivery> = ({
    deliveryProps,
    heading,
    count,
    processing,
    address,
    trackingInfo,
    pickupDateTimeslot
}) => (
    <Node {...deliveryProps}>
        {heading}
        {address}
        {pickupDateTimeslot}
    </Node>
);

export const OrderConfirmationGroup: React.FC<IGroup> = ({ groupProps, delivery, salesLinesProps, salesLines }) => (
    <Node {...groupProps}>
        {delivery && <OrderConfirmationGroupDelivery {...delivery} />}
        {/*{delivery && delivery.shippingItemsToYou}*/}
        {/*{salesLines && (*/}
        {/*    <Node {...salesLinesProps}>*/}
        {/*        {salesLines.map((salesLine: ISalesLine) => (*/}
        {/*            <OrderConfirmationSalesLine key={salesLine.data.salesLine.LineId} {...salesLine} />*/}
        {/*        ))}*/}
        {/*    </Node>*/}
        {/*)}*/}
    </Node>
);

export const OrderConfirmationGroups: React.FC<IGroups> = ({ groupsProps, groups }) => (
    <Node {...groupsProps}>
        {groups.map((group: IGroup, index: number) => (
            <OrderConfirmationGroup key={index} {...group} />
        ))}
    </Node>
);

export const OrderConfirmationOrderSummary: React.FC<IOrderSummary> = ({
    orderSummaryProps,
    heading,
    subtotal,
    shipping,
    tax,
    totalAmount,
    earnedPoints
}) => (
    <Node {...orderSummaryProps}>
        {heading}
        {subtotal}
        {/*{shipping}*/}
        {tax}
        {totalAmount}
        {earnedPoints}
    </Node>
);

export const OrderConfirmationPayment: React.FC<IPaymentMethods> = ({ paymentMethodsProps, title, methods }) => (
    <Node {...paymentMethodsProps}>
        {title}
        {methods}
    </Node>
);

export const OrderConfirmationHelp: React.FC<IHelp> = ({ helpProps, needHelpLabel, helpLineNumberLabel, contactNumber }) => (
    <Node {...helpProps}>
        {needHelpLabel}
        {helpLineNumberLabel}
        {contactNumber}
    </Node>
);

const OrderConfirmationView: React.FC<IOrderConfirmationViewProps> = ({
    moduleProps,
    heading,
    backToShoppingLink,
    alert,
    loading,
    orderInfomation,
    orderSummary,
    payment,
    help,
    groups,
    state,
    props
}) => {
    const defaultImageSettings: IImageSettings = {
        viewports: {
            xs: { q: 'w=100&h=100&m=6', w: 100, h: 100 },
            lg: { q: 'w=100&h=100&m=6', w: 100, h: 100 },
            xl: { q: 'w=100&h=100&m=6', w: 100, h: 100 }
        },
        lazyload: true,
        cropFocalRegion: true
    };
    const rounded = (ringSize?: number) => {
        if (ringSize) {
            return ringSize.toFixed(2);
        }
        return '';
    };
    return (
        <Module {...moduleProps}>
            {heading}
            <span className={'order-confirmation-heading-message'}>{props.resources.thankYouMessage}</span>
            {alert}
            {loading}
            <div style={{ borderBottom: '0.5px solid #C4C4C4', paddingTop: '70px', marginBottom: '10px' }}>
                {orderInfomation && <OrderConfirmationOrderInfomation {...orderInfomation} />}
                {/*{backToShoppingLink}*/}
                {groups && <OrderConfirmationGroups {...groups} />}
            </div>
            {/*{payment && <OrderConfirmationPayment {...payment} />}*/}
            {/*{orderSummary && <OrderConfirmationOrderSummary {...orderSummary} />}*/}
            {help && <OrderConfirmationHelp {...help} />}
            {state.updatedSalesLines &&
                state.updatedSalesLines.length > 0 &&
                state.updatedSalesLines.map((salesLines: any) => {
                    return (
                        <>
                            <div>
                                <div className={'row'}>
                                    <div className='col-md-1'>
                                        <Image
                                            requestContext={props.context.actionContext.requestContext}
                                            altText={salesLines.productName}
                                            className='ms-wishlist-items__product-image'
                                            title={salesLines.productName}
                                            src={salesLines.BmaImageUrl}
                                            fallBackSrc={salesLines.BmaImageUrl}
                                            gridSettings={props.context.request.gridSettings!}
                                            imageSettings={defaultImageSettings}
                                            loadFailureBehavior={'empty'}
                                        />
                                    </div>
                                    <div className='col-md-11 order-confirmation-content'>
                                        <div className={'order-confirmation-sumary-product'}>{salesLines.productName}</div>
                                        <div>
                                            <table>
                                                <tr className={'ms-order-confirmation-container'}>
                                                    {salesLines.ItemInfo.rings &&
                                                        salesLines.ItemInfo.rings.map((ring: any, index: number) => {
                                                            return (
                                                                <div
                                                                    key={ring.ringId}
                                                                    className={'ms-order-confirmation-container__cart-item'}
                                                                >
                                                                    <td className={'ring-name'}>
                                                                        <span className={'order-confirmation-summary-heading'}>
                                                                            {ring.ringName}
                                                                        </span>
                                                                        {/*<span>Colors : {ring.ringFinenessColorPolishInfo.length}</span>*/}
                                                                        <span>
                                                                            {ring.ringFinenessColorPolishInfo.map(
                                                                                (r: any, index: number) => {
                                                                                    return <div key={index}>{r}</div>;
                                                                                }
                                                                            )}
                                                                        </span>
                                                                    </td>
                                                                    <td className={'ring-size'}>
                                                                        <span className={'order-confirmation-summary-heading'}>
                                                                            {'Size'}
                                                                        </span>
                                                                        <span>
                                                                            Size {ring.sizeLabel} ( &Oslash; {rounded(ring.sizeValue)}mm)
                                                                        </span>
                                                                    </td>
                                                                    <td className={'ring-specification'}>
                                                                        <span className={'order-confirmation-summary-heading'}>
                                                                            {'Specification'}
                                                                        </span>
                                                                        <span>{ring.specifications}</span>
                                                                        {ring.engraving !== '' && <span>{', Engraving'}</span>}
                                                                    </td>
                                                                    <td className={'ring-snapshot-id'}>
                                                                        <span className={'order-confirmation-summary-heading'}>
                                                                            {index === 0 ? 'Snapshot Id' : ''}
                                                                        </span>
                                                                        <span className={'order-confirmation-summary-text snapshot-id'}>
                                                                            {index === 0 ? salesLines.snapshotProperty : ''}
                                                                        </span>
                                                                    </td>
                                                                    <td className={'ring-quantity'}>
                                                                        <span className={'order-confirmation-summary-heading'}>
                                                                            {index === 0 ? 'Quantity' : ''}
                                                                        </span>
                                                                        <span className={'order-confirmation-summary-text'}>
                                                                            {index === 0 ? salesLines.ItemInfo.quantity : ''}
                                                                        </span>
                                                                    </td>
                                                                    <td className={'ring-customer-reference'}>
                                                                        <span className={'order-confirmation-summary-heading'}>
                                                                            {index === 0 ? 'Customer Reference' : ''}
                                                                        </span>
                                                                        <span className={'order-confirmation-summary-text'}>
                                                                            {index === 0 ? salesLines.customerReference : ''}
                                                                        </span>
                                                                    </td>
                                                                    <td className={'ring-price'}>
                                                                        <span className={'order-confirmation-summary-heading'}>
                                                                            {'Price'}
                                                                        </span>
                                                                        <span>
                                                                            {props.context.cultureFormatter.formatCurrency(
                                                                                ring.priceAmount
                                                                            )}
                                                                        </span>
                                                                    </td>
                                                                </div>
                                                            );
                                                        })}
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div className={'order-confirmation-summary-price-total'}>
                                    <span className={'order-confirmation-summary-price-total-heading'}>{'Total incl. GST   '}</span>
                                    <span className={'order-confirmation-summary-price-total-text'}>
                                        {props.context.cultureFormatter.formatCurrency(salesLines.ItemInfo.priceAmount)}
                                    </span>
                                </div>
                            </div>
                        </>
                    );
                })}
            {state.totalAmount > 0 && state.updatedSalesLines.length > 1 && (
                <div className={'order-confirmation-summary-grand-total'}>
                    <span>{'Grand Total  '}</span>
                    <span>{props.context.cultureFormatter.formatCurrency(state.totalAmount)}</span>
                </div>
            )}
        </Module>
    );
};

export default OrderConfirmationView;
